import { render } from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=template&id=fa4223da&scoped=true"
import script from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=script&lang=js"
export * from "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=script&lang=js"

import "./InstanceVolumesStoragePoolSelectListView.vue?vue&type=style&index=0&id=fa4223da&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4223da"]])

export default __exports__